module.exports = __webpack_public_path__ + "img/thumbnail_Emu_j_normal.ef00d47a.png";